/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Carry_Why_HeavierInputs */

const en_us2_workout_after_carry_why_heavier = /** @type {(inputs: Workout_After_Carry_Why_HeavierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The last two times you lifted more than the plan.`)
};

const pt_br2_workout_after_carry_why_heavier = /** @type {(inputs: Workout_After_Carry_Why_HeavierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nas duas últimas vezes você usou mais carga que o plano.`)
};

const es_419_workout_after_carry_why_heavier = /** @type {(inputs: Workout_After_Carry_Why_HeavierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las dos últimas veces levantaste más que el plan.`)
};

const pt_pt2_workout_after_carry_why_heavier = /** @type {(inputs: Workout_After_Carry_Why_HeavierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nas duas últimas vezes usaste mais carga do que o plano.`)
};

const fr_fr2_workout_after_carry_why_heavier = /** @type {(inputs: Workout_After_Carry_Why_HeavierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les deux dernières fois, tu as soulevé plus que le programme.`)
};

const de_de2_workout_after_carry_why_heavier = /** @type {(inputs: Workout_After_Carry_Why_HeavierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die letzten zwei Male hast du mehr bewegt als im Plan.`)
};

const it_it2_workout_after_carry_why_heavier = /** @type {(inputs: Workout_After_Carry_Why_HeavierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le ultime due volte hai sollevato più di quanto previsto dalla scheda.`)
};

/**
* | output |
* | --- |
* | "The last two times you lifted more than the plan." |
*
* @param {Workout_After_Carry_Why_HeavierInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_carry_why_heavier = /** @type {((inputs?: Workout_After_Carry_Why_HeavierInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Carry_Why_HeavierInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_carry_why_heavier(inputs)
	if (locale === "es-419") return es_419_workout_after_carry_why_heavier(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_carry_why_heavier(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_carry_why_heavier(inputs)
	if (locale === "de-DE") return de_de2_workout_after_carry_why_heavier(inputs)
	if (locale === "it-IT") return it_it2_workout_after_carry_why_heavier(inputs)
	return en_us2_workout_after_carry_why_heavier(inputs)
});
export { workout_after_carry_why_heavier as "workout-after.carry_why_heavier" }